import { AllowedConnectorTypes } from '../config/allowed-connector-types';
import {
  AllowedFormatTypes,
  AllowedReadFormatTypes,
  AllowedWriteFormatTypes,
} from '../config/allowed-format-types';
import { AllowedStatementTypes } from '../config/allowed-statement-types';
import { AllowedTaskTypes } from '../config/allowed-task-types';
import dataframes from '../config/dataframe-nodes';
import { colors } from '../theme/colors';

// Base styles
export const baseNodeStyles = {
  padding: '10px',
  borderRadius: '5px',
  fontSize: '12px',
  width: '150px',
  textAlign: 'center',
  cursor: 'pointer',
  border: `2px solid ${colors.navy}`,
  whiteSpace: 'normal',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
};

export const baseNodeStylesV2 = {
  padding: '2px',
  borderRadius: '5px',
  fontSize: '12px',
  width: '100px',
  textAlign: 'center',
  cursor: 'pointer',
  whiteSpace: 'normal',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
};

// V1 node-specific styles
export const connectorNodeStyles = {
  ...baseNodeStyles,
  background: colors.lightPurple,
};

export const taskNodeStyles = {
  ...baseNodeStyles,
  background: colors.blue,
};

export const commandNodeStyles = {
  ...baseNodeStyles,
  background: colors.orange,
};

export const dataframeNodeStyles = {
  ...baseNodeStyles,
  background: colors.teal,
};

export const formatNodeStyles = {
  ...baseNodeStyles,
  background: colors.pink,
};

// V2 node-specific styles
export const connectorNodeStylesV2 = {
  ...baseNodeStylesV2,
  // Additional connector-specific styles for V2
};

export const taskNodeStylesV2 = {
  ...baseNodeStylesV2,
  // background: colors.blue,
};

export const commandNodeStylesV2 = {
  ...baseNodeStylesV2,
  // background: colors.orange,
};

export const dataframeNodeStylesV2 = {
  ...baseNodeStylesV2,
  // background: colors.teal,
};

export const formatNodeStylesV2 = {
  ...baseNodeStylesV2,
  // background: colors.pink,
};

// Error styles (for backward compatibility)
export const errorNodeStyles = {
  ...connectorNodeStyles,
  border: `2px solid #FF4B93`,
};

export const errorNodeStylesV2 = {
  ...connectorNodeStylesV2,
  border: `2px solid #FF4B93`,
};

// Common element styles
export const nodeStyles = {
  nodeLabel: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '180px',
    padding: '0 8px',
  },
  errorIcon: {
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    color: '#FF4B93',
    zIndex: 10,
  },
};
/**
 * Get the appropriate node style based on node type, error state, and icon presence
 * @param {string} type - The node type (connector, task, command, dataframe, format)
 * @param {boolean} isError - Whether the node has an error
 * @param {boolean} hasIcon - Whether the node has an icon (determines if V2 style is used)
 * @returns {Object} The style object for the node
 */
export const getNodeStyle = (type, isError = false, hasIcon = false) => {
  let baseStyle;
  if (hasIcon) {
    // V2 styles with icons
    if (AllowedConnectorTypes.includes(type)) {
      baseStyle = connectorNodeStylesV2;
    } else if (AllowedTaskTypes.includes(type)) {
      baseStyle = taskNodeStylesV2;
    } else if (dataframes.some((df) => df.type === type)) {
      baseStyle = dataframeNodeStylesV2;
    } else if (AllowedStatementTypes.includes(type?.replace('Command', ''))) {
      baseStyle = commandNodeStylesV2;
    } else if ([...AllowedReadFormatTypes, ...AllowedWriteFormatTypes].includes(type)) {
      baseStyle = formatNodeStylesV2;
    } else {
      baseStyle = connectorNodeStylesV2; // Default
    }
  } else {
    // V1 styles without icons
    if (AllowedConnectorTypes.includes(type)) {
      baseStyle = connectorNodeStyles;
    } else if (AllowedTaskTypes.includes(type)) {
      baseStyle = taskNodeStyles;
    } else if (dataframes.some((df) => df.type === type)) {
      baseStyle = dataframeNodeStyles;
    } else if (AllowedStatementTypes.includes(type?.replace('Command', ''))) {
      baseStyle = commandNodeStyles;
    } else if (AllowedFormatTypes.includes(type)) {
      baseStyle = formatNodeStyles;
    } else {
      baseStyle = connectorNodeStyles; // Default
    }
  }

  if (isError) {
    return {
      ...baseStyle,
      border: `2px solid #FF4B93`,
    };
  }

  return baseStyle;
};
